const base = import.meta.env.BASE_URL

const IMAGE_MAPPING = {
  error: `${base}images/error.png`,
  logoPayuFinanceWhite: `${base}images/logos/logo-white-payu-finance.png`,
  bgIcon: `${base}images/bg-icon.png`,
  splitLayoutBg: `${base}images/bg.png`,
  payufin_logo: 'https://assets.payufin.com/images/payu-finance-new-logo.png'
}

export const getImageUrl = icon => IMAGE_MAPPING[icon] ?? IMAGE_MAPPING.error
